import {
  CollapsiblePanel,
  CustomLabel,
  DraftEditor,
  FlexContainer,
  Input,
} from "@mindmemobile/mm-shared-global";
import { inject, observer } from "mobx-react";
import React from "react";
import { DonationStore } from "../../../shared/store";
import { DonationPricingPageInputsModel } from "../../../shared/models";
import { DescriptionCell, LabelCell } from "../../../shared/styles";
import { convertToRaw, EditorState } from "draft-js";

type IProps = {
  donationStore?: DonationStore;
};

@inject("donationStore")
@observer
class DonationSetupSection extends React.Component<IProps> {
  get donationStore() {
    return this.props.donationStore;
  }

  updateState(
    key: keyof DonationPricingPageInputsModel,
    value: string | EditorState
  ) {
    if (!this.donationStore) return;
    this.props.donationStore?.updateScrollToField(key);
    switch (key) {
      case "title":
        this.props.donationStore?.updatePricingPageData(
          new DonationPricingPageInputsModel({
            ...this.donationStore.pricingPageData,
            title: value as string,
          })
        );
        break;
      case "subTitle":
        this.props.donationStore?.updatePricingPageData(
          new DonationPricingPageInputsModel({
            ...this.donationStore.pricingPageData,
            subTitle: value as string,
          })
        );
        break;
      case "subTitleEditorState":
        const editorState = value as EditorState;
        this.props.donationStore?.updatePricingPageData(
          new DonationPricingPageInputsModel({
            ...this.donationStore.pricingPageData,
            subTitleEditorState: editorState,
            subTitle: editorState.getCurrentContent().getPlainText(),
            subTitleEditorRawContent: JSON.stringify(
              convertToRaw(editorState.getCurrentContent())
            ),
          })
        );
        break;
      case "titleEditorState":
        const titleEditorState = value as EditorState;
        this.props.donationStore?.updatePricingPageData(
          new DonationPricingPageInputsModel({
            ...this.donationStore.pricingPageData,
            titleEditorState: titleEditorState,
            title: titleEditorState.getCurrentContent().getPlainText(),
            titleEditorRawContent: JSON.stringify(
              convertToRaw(titleEditorState.getCurrentContent())
            ),
          })
        );
    }
  }

  render() {
    return (
      <CollapsiblePanel title="Setup">
        <FlexContainer className="label-description-row">
          <LabelCell>
            <CustomLabel lineHeight="40px" fontSize="16px">
              Donate Title
            </CustomLabel>
          </LabelCell>
          <DescriptionCell>
            {/* <Input
              error={this.donationStore?.pricingPageData.hasError("title")}
              type="text"
              value={this.donationStore?.pricingPageData.title || ""}
              onChange={(e) => this.updateState("title", e.target.value)}
              placeholder="Make a difference today"
            /> */}
            <DraftEditor
              editorState={
                this.donationStore?.pricingPageData.titleEditorState ||
                EditorState.createEmpty()
              }
              onChange={(newValue: EditorState) =>
                this.updateState("titleEditorState", newValue)
              }
              className="product-detail-editor"
              showErrorBorder={this.donationStore?.pricingPageData.hasError(
                "title"
              )}
            />
          </DescriptionCell>
        </FlexContainer>
        <FlexContainer className="label-description-row">
          <LabelCell>
            <CustomLabel lineHeight="40px" fontSize="16px">
              Donate Sub-Title
            </CustomLabel>
          </LabelCell>
          <DescriptionCell className="donation-textarea-plh">
            <DraftEditor
              editorState={
                this.donationStore?.pricingPageData.subTitleEditorState ||
                EditorState.createEmpty()
              }
              onChange={(newValue: EditorState) =>
                this.updateState("subTitleEditorState", newValue)
              }
              className="product-detail-editor"
            />
            {/* <Input
              error={this.donationStore?.pricingPageData.hasError("subTitle")}
              type="textarea"
              value={this.donationStore?.pricingPageData.subTitle || ""}
              onChange={(e) => this.updateState("subTitle", e.target.value)}
              placeholder="Help make a difference today!"
            /> */}
          </DescriptionCell>
        </FlexContainer>
      </CollapsiblePanel>
    );
  }
}

export default DonationSetupSection;
